import * as React from "react";
import "../Styles/style.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import { awsImageURL, baseUrl } from "../../api/ipconfig";
import { Link, useLocation } from "react-router-dom";
import Lottie from "lottie-react";
import NotAvailable from "../../images/not-found.json";
import { Pagination } from "@mui/material";

export default function NewCarsList() {
  const history = useHistory();

  const [newCarsList, setNewCarsList] = React.useState(null);
  const [make, setMake] = React.useState(null);
  const [makeId, setMakeId] = React.useState(null);
  const [totalPages, setTotalPages] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/newCarsListByMake`, {
        params: {
          make_id: makeId,
          page: page,
        },
      });

      setNewCarsList(response?.data?.data);
      setTotalPages(response?.data?.last_page);
      setPage(response?.data?.current_page);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  React.useEffect(() => {
    if (makeId) {
      fetchData();
    }
  }, [makeId, page]);

  React.useEffect(() => {
    const handleUrlChange = () => {
      const url = window.location.href;
      const parts = url.split("/");
      const param = url.split("?make=");
      // setUrlToken(parts[1] || null);

      const makeValue = param[1].split("/")[0];

      setMakeId(parts[4] || null);
      setMake(makeValue || null);
    };

    handleUrlChange();

    const unlisten = history.listen(() => {
      handleUrlChange();
    });

    return () => {
      unlisten();
    };
  }, [history]);

  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };

  return (
    <>
      <div className="container">
        <div className="text-center py-5">
          <h2 className="text-start section-titles pb-3 ">
            Explore New {make} cars
          </h2>

          <div>
            {newCarsList?.length === 0 ? (
              <div className="notBidsAvail text-center">
                <Lottie
                  style={{ height: 200 }}
                  animationData={NotAvailable}
                  loop
                />
                <h5 className="fw-600">No cars available</h5>
              </div>
            ) : (
              <>
                <div className="row">
                  {newCarsList &&
                    newCarsList?.map((item) => (
                      <div
                        className="col-lg-3 col-md-4 col-6 mb-3 p-2 cursorPointer "
                        key={`${item?.newcarpost_id}${item?.make}`}
                      >
                        <Link
                          to={`/new-car-specs?make=${item?.make}/${item?.newcarpost_id}`}
                        >
                          <div className="adPost text-start">
                            <div className="position-relative m-2">
                              <img
                                src={`${awsImageURL}/posts/${item?.newcarpost_token}/${item?.newcarpost_cover}`}
                                alt={`${item?.make} ${item?.model_name}`}
                                style={{
                                  boxShadow: "unset",
                                  objectFit: "contain",
                                }}
                                onError={(e) => {
                                  e.target.src =
                                    "https://gallery.famewheels.com/appgallery/no-image.png";
                                }}
                              />
                            </div>

                            <div className=" p-2 ">
                              <h5 className="fw-600 ad-Title color-black text-capitalize mb-1 text-center">
                                {item?.make} {item?.model_name}
                              </h5>
                              <h4
                                style={{ color: "#20409a" }}
                                className="fw-600 text-center adPrice mb-1"
                              >
                                <span style={{ color: "#20409a" }}>
                                  PKR {formatPrice(item?.newcarpost_price)}
                                </span>
                              </h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                </div>
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={handleChange}
                  color="secondary"
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
